import PropTypes from 'prop-types';
import FormattedName from 'I18n/components/FormattedName';
import styled from 'styled-components';
import { getTextColor } from '../../utils/color';
import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { DateIcon, EmailIcon } from 'foundations-assets';
import { trackInteraction } from '../../tracking/tracker';
import ViewSenderAvatar from './ViewSenderAvatar';
import ViewSenderPopoverButton from './ViewSenderPopoverButton';
import { CLICKED_REPS_EMAIL, CLICKED_REPS_MEETING_LINK } from '../../tracking/actions';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const PopoverArrow = styled.div.withConfig({
  displayName: "ViewSenderPopoverContent__PopoverArrow",
  componentId: "sc-198stq1-0"
})(({
  backgroundColor,
  theme: _theme
}) => {
  const theme = _theme;
  return {
    backgroundColor,
    width: '20px',
    height: '20px',
    transform: 'rotate(-135deg)',
    position: 'absolute',
    top: '-10px',
    left: '254px',
    borderWidth: theme.borderWidth[100],
    borderStyle: 'solid',
    borderColor: theme.color['border-core-default'],
    borderTopColor: 'transparent !important',
    borderLeftColor: 'transparent !important'
  };
});
const StyledPopoverContentContainer = styled.div.withConfig({
  displayName: "ViewSenderPopoverContent__StyledPopoverContentContainer",
  componentId: "sc-198stq1-1"
})(({
  backgroundColor,
  color,
  theme: _theme
}) => {
  const theme = _theme;
  return {
    backgroundColor,
    color,
    padding: theme.space['600'],
    borderRadius: '2px'
  };
});
const ViewSenderPopoverContent = ({
  meetingLink,
  firstName,
  lastName,
  email,
  brandingColor
}) => {
  const meetingsLinkButton = meetingLink && /*#__PURE__*/_jsx(ViewSenderPopoverButton, {
    icon: /*#__PURE__*/_jsx(DateIcon, {}),
    message: "view.toolbar.sender.meetingsLink",
    onClick: () => trackInteraction(CLICKED_REPS_MEETING_LINK),
    href: meetingLink,
    target: "_blank"
  });
  const textColor = getTextColor(brandingColor);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(PopoverArrow, {
      backgroundColor: brandingColor
    }), /*#__PURE__*/_jsxs(StyledPopoverContentContainer, {
      backgroundColor: brandingColor,
      color: textColor,
      children: [/*#__PURE__*/_jsxs(Flex, {
        flexDirection: "row",
        alignItems: "center",
        children: [/*#__PURE__*/_jsx(View, {
          borderRadius: "full",
          borderColor: "border-core-on-fill-default",
          borderWidth: "200",
          borderStyle: "solid",
          marginInlineEnd: "300",
          children: /*#__PURE__*/_jsx(Flex, {
            children: /*#__PURE__*/_jsx(ViewSenderAvatar, {
              "aria-hidden": "true",
              email: email,
              size: "md"
            })
          })
        }), /*#__PURE__*/_jsxs(Flex, {
          flexDirection: "column",
          children: [/*#__PURE__*/_jsx(Text, {
            as: "h5",
            color: "text-core-on-fill-default",
            children: /*#__PURE__*/_jsx(FormattedName, {
              familyName: lastName,
              givenName: firstName
            })
          }), /*#__PURE__*/_jsx("div", {
            children: email
          })]
        })]
      }), /*#__PURE__*/_jsxs(Flex, {
        marginBlockStart: "500",
        justifyContent: "center",
        children: [meetingsLinkButton, /*#__PURE__*/_jsx(ViewSenderPopoverButton, {
          icon: /*#__PURE__*/_jsx(EmailIcon, {}),
          href: `mailto:${email}`,
          message: "view.toolbar.sender.emailLink",
          onClick: () => trackInteraction(CLICKED_REPS_EMAIL)
        })]
      })]
    })]
  });
};
ViewSenderPopoverContent.propTypes = {
  meetingLink: PropTypes.string,
  email: PropTypes.string.isRequired,
  brandingColor: PropTypes.string.isRequired,
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired
};
export default ViewSenderPopoverContent;